import React from "react";
import { Button, Card, TextInput, Modal, Text, Group, Stack } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useTrans } from "core";
import api from "../services/ApiService";
import { showNotification } from "@mantine/notifications";
import { MSIcon } from "components/MSIcon";
import { Api_CancelConfirmed } from "../../../constants/SubApi.js";

export default function CanceledReserve() {
	const { t } = useTrans();
	const navigate = useNavigate();

	const [reservationCode, setReservationCode] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const [confirmOpen, setConfirmOpen] = React.useState(false);

	const notifyError = (message) => {
		showNotification({
			title: t("messages.error"),
			message: message,
			color: "red",
		});
	};

	const notifySuccess = (message) => {
		showNotification({
			title: t("messages.success"),
			message: message,
			color: "green",
		});
	};

	const handleConfirm = async () => {
		setConfirmOpen(false);

		if (!reservationCode.trim()) {
			notifyError(t("canceledReserveation.codeReserveNumAlert"));
			return;
		}

		setLoading(true);
		try {
			const payload = { code: reservationCode.trim() };
			await api.post(`/${Api_CancelConfirmed}`, payload);

			notifySuccess(t("messages.successCanceledReserve"));

			navigate("/", { replace: true });
		} catch (err) {
			const res = err?.data || {};
			const key = res.message || "messages.error";

			notifyError(t(key));
		}

		setLoading(false);
	};

	return (
		<>
			{/* Confirm Dialog */}
			<Modal opened={confirmOpen} onClose={() => setConfirmOpen(false)} centered>
				<Stack>
					<Text size="lg" fw={700}>
						{t("baseApartmentDetails.canceledReserve")}
					</Text>
					<Text>{t("baseApartmentDetails.canceledReserveSure")}</Text>

					<Group justify="flex-end" mt="md">
						<Button variant="default" onClick={() => setConfirmOpen(false)}>
							{t("baseApartmentDetails.cancel")}
						</Button>

						<Button onClick={handleConfirm}>{t("baseApartmentDetails.confirm")}</Button>
					</Group>
				</Stack>
			</Modal>

			{/* Main Page */}
			<Card shadow="md" radius="md" p="lg" withBorder style={{ maxWidth: 450, margin: "40px auto" }}>
				<Stack gap="lg">
					<Text fw={700} size="lg">
						{t("canceledReserveation.confirmCanceledReserve")}
					</Text>

					<TextInput
						label={t("canceledReserveation.reserveCode")}
						value={reservationCode}
						onChange={(e) => setReservationCode(e.target.value)}
					/>

					<Button
						fullWidth
						loading={loading}
						onClick={() => setConfirmOpen(true)}
						leftSection={<MSIcon name="CloseCircleOutline" />}
					>
						{t("canceledReserveation.canceledReserve")}
					</Button>
				</Stack>
			</Card>
		</>
	);
}
